import { render } from "./PerformanceDisplay.vue?vue&type=template&id=4d628057&scoped=true"
import script from "./PerformanceDisplay.vue?vue&type=script&lang=js"
export * from "./PerformanceDisplay.vue?vue&type=script&lang=js"

import "./PerformanceDisplay.vue?vue&type=style&index=0&id=4d628057&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d628057"]])

export default __exports__